module.exports = __webpack_public_path__ + "res/Roboto-CondensedItalic-webfont.ttf?f97ec545d9da6f5db884b4559b226350";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-CondensedItalic-webfont.ttf
// module id = 39
// module chunks = 0